export default __webpack_public_path__ + "static/media/MN.555e4cde.svg";